<template>
  <v-layout class="justify-center">
    <v-card>
      <br>
      <img src="@/assets/calendar.png">
      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-0">Antecipação</h3>
          <p>Antecipe seu crédito e receba direto na sua conta digital {{ appName }}</p>
        </div>
      </v-card-title>
      <v-card-actions>
        <select-anticipations-recharge-button/>
      </v-card-actions>
      <select-anticipations-recharge/>
    </v-card>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AnticipationRecharge',
  mounted() {
    this.$store.dispatch('user/getAnticipationTax');
    this.$store.dispatch('user/getBalance');
    this.$store.dispatch('system/fetchSystemConfiguration');
  },
  computed: {
    ...mapGetters({
      tax: 'user/anticipationTax',
      AnticipationBalance: 'user/balance',
      systemAppName: 'system/appName',
    },
    ),
    appName() {
      return this.systemAppName || process.env.VUE_APP_APP_NAME || 'FlowIt';
    },
  },
  components: {
    SelectAnticipationsRecharge: () => import('@/components/recharge/actions/SelectAnticipationsRecharge.vue'),
    SelectAnticipationsRechargeButton: () => import('@/components/recharge/actions/SelectAnticipationsButton.vue'),
  },
};
</script>
